/*
 * Enhanced ArgoCD Config Hook - Adapted for Roadie Plugin Compatibility
 * Based on @backstage-community/plugin-redhat-argocd
 */

import { configApiRef, useApi } from '@backstage/core-plugin-api';

export interface Instance {
  name: string;
  url: string;
}

export const useArgocdConfig = (): {
  instances: Instance[];
  intervalMs: number;
  baseUrl: string | undefined;
} => {
  const configApi = useApi(configApiRef);

  // 兼容 Roadie 插件的配置格式
  const instances = (
    configApi
      .getConfigArray('argocd.appLocatorMethods')
      .find(value => value.getOptionalString('type') === 'config')
      ?.getOptionalConfigArray('instances') ?? []
  ).map(config => ({
    name: config.getOptionalString('name') ?? 'default',
    url: config.getOptionalString('url') ?? '',
  }));

  // 默认刷新间隔（毫秒）
  const intervalMs = configApi.getOptionalNumber('argocd.refreshInterval') ?? 10000;
  
  // ArgoCD Web UI 基础 URL
  const baseUrl = configApi.getOptionalString('argocd.baseUrl');

  return { baseUrl, instances, intervalMs };
};
